import styled from "styled-components";
import {Text1} from "../../../styles/components";

export const Container = styled.div`
  padding: 0 10px;
  margin: 10vh 0;
  height: 100%;

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    padding: 0 12%;
  }
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 80px;
  align-self: stretch;
`

export const Content = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 50px;
  width: 100%;
`

export const TextBlock = styled.div`
  display: flex;
  width: 800px;
  flex-direction: column;
  align-items: flex-start;
  gap: 50px;
  flex-shrink: 0;
`

export const Title = styled.div`
  & svg {
    #text path {
      fill: ${({theme}) => theme.colors.secondaryFont};
    }
  }
`

export const Text = styled(Text1)`
  line-height: 50px;
`

export const ImageBlock = styled.div`
  flex: 1 0 0;
  align-self: stretch;
`

export const Image = styled.img`
    width: 100%;
`